module.exports = __webpack_public_path__ + "img/programmer.fd653886.gif";